import { render, staticRenderFns } from "./Demographics.vue?vue&type=template&id=7bdf7f25&scoped=true"
import script from "./Demographics.vue?vue&type=script&lang=js"
export * from "./Demographics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdf7f25",
  null
  
)

export default component.exports